export const API_URL = process.env.REACT_APP_API_URL || 'https://demolqdtu.click/api';
export const IMAGE_BASE_URL = process.env.REACT_APP_IMAGE_BASE_URL || 'https://api.lqdtu.edu.vn';
export const SETTING_IMAGE_URL = process.env.REACT_APP_SETTING_IMAGE_URL || 'https://demolqdtu.click';
// Special case for banners and specific image APIs that remain on the old domain
export const OLD_API_URL = 'https://api.lqdtu.edu.vn/api';
